import { useContext } from "react";
import {
  Alpha1Set,
  Area1Set,
  Ratio1Set,
  Area2Set,
  Ratio2Set,
  ModeSet,
} from "../../App";
import Csv2kml from "../../makekml/csv2kml";

export function Modalsyosai({ metadata, metadata2, show, setShow }) {
  const { area1set } = useContext(Area1Set);
  const { ratio1set } = useContext(Ratio1Set);
  const { area2set } = useContext(Area2Set);
  const { ratio2set } = useContext(Ratio2Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { modeset } = useContext(ModeSet);

  if (show) {
    return (
      <>
        <div
          id="overlay"
          onClick={() => setShow(false)}
          className="flex items-center top-0 left-0 w-full"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="text-white bg-gradient-to-r from-black/100 to-black/90 font-medium rounded-lg mx-auto w-5/6 h-screen overflow-y-auto"
          >
            <div
              onClick={() => setShow(false)}
              className="flex justify-end mt-2 mr-2 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>



            {(modeset == 8 &&
            <table className="mx-5">
              <caption className="text-2xl text-extrabold text-white md:p-2">
                データ詳細（左側）
              </caption>
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  ></th>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  >
                    高さ
                  </th>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  >
                    色
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    観点
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.title_height_name}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.title_color_name}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    凡例名
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.hanrei_height_name}
                    {metadata2.hanrei_height_name_2}
                    {metadata2.hanrei_height_name_3}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.hanrei_color_name}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    年次
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.year_display}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.year_syousai}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    出典
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.height_origin}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata2.color_origin}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    定義
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 dark:text-gray-400  break-words">
                    {metadata2.height_origin_note}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 break-words dark:text-gray-400">
                    {metadata2.color_origin_note}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    詳細
                  </td>
                  <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                    <a href={metadata2.height_origin_url}>
                      {metadata2.height_origin_url_name}
                    </a>{" "}
                    <br />
                    <a href={metadata2.height_origin_url2}>
                      {metadata2.height_origin_url2_name}
                    </a>
                    <br />
                    <a href={metadata2.height_origin_url3}>
                      {metadata2.height_origin_url3_name}
                    </a>
                    <br />
                    <a href={metadata2.height_origin_url4}>
                      {metadata2.height_origin_url4_name}
                    </a>
                  </td>
                  <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                    <a href={metadata2.color_origin_url}>
                      {metadata2.color_origin_url_name}
                    </a>
                    <br />
                    <a href={metadata2.color_origin_url2}>
                      {metadata2.color_origin_url2_name}
                    </a>
                    <br />
                    <a href={metadata2.color_origin_url3}>
                      {metadata2.color_origin_url3_name}
                    </a>
                    <br />
                    <a href={metadata2.color_origin_url4}>
                      {metadata2.color_origin_url4_name}
                    </a>
                  </td>
                </tr>

                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  {metadata2.kml_ok == 1 && modeset != 3 && (
                    <>
                      <td
                        colSpan={3}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area1set}
                            ratio={ratio1set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                    </>
                  )}
                  {metadata2.kml_ok == 1 && modeset == 3 && (
                    <>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      ></td>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area2set}
                            ratio={ratio2set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード（左側）
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area1set}
                            ratio={ratio1set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード（右側）
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>
)}




            <table className="mx-5">
              <caption className="text-2xl text-extrabold text-white md:p-2">
                データ詳細
              {(modeset == 8 && "（右側）" )}
              </caption>
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  ></th>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  >
                    高さ
                  </th>
                  <th
                    scope="col"
                    className="py-4 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400"
                  >
                    色
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    観点
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.title_height_name}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.title_color_name}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    凡例名
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.hanrei_height_name}
                    {metadata.hanrei_height_name_2}
                    {metadata.hanrei_height_name_3}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.hanrei_color_name}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    年次
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.year_display}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.year_syousai}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    出典
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.height_origin}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                    {metadata.color_origin}
                  </td>
                </tr>
                {/* <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    測地系
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 dark:text-gray-400  break-words">
                    {metadata.sokuchi}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 break-words dark:text-gray-400">
                    {metadata.sokuchi}
                  </td>
                </tr> */}
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    定義
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 dark:text-gray-400  break-words">
                    {metadata.height_origin_note}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500 break-words dark:text-gray-400">
                    {metadata.color_origin_note}
                  </td>
                </tr>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    詳細
                  </td>
                  <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                    <a href={metadata.height_origin_url}>
                      {metadata.height_origin_url_name}
                    </a>{" "}
                    <br />
                    <a href={metadata.height_origin_url2}>
                      {metadata.height_origin_url2_name}
                    </a>
                    <br />
                    <a href={metadata.height_origin_url3}>
                      {metadata.height_origin_url3_name}
                    </a>
                    <br />
                    <a href={metadata.height_origin_url4}>
                      {metadata.height_origin_url4_name}
                    </a>
                  </td>
                  <td className="py-4 px-6 text-sm text-blue-500 underline break-words">
                    <a href={metadata.color_origin_url}>
                      {metadata.color_origin_url_name}
                    </a>
                    <br />
                    <a href={metadata.color_origin_url2}>
                      {metadata.color_origin_url2_name}
                    </a>
                    <br />
                    <a href={metadata.color_origin_url3}>
                      {metadata.color_origin_url3_name}
                    </a>
                    <br />
                    <a href={metadata.color_origin_url4}>
                      {metadata.color_origin_url4_name}
                    </a>
                  </td>
                </tr>

                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  {metadata.kml_ok == 1 && modeset != 3 && (
                    <>
                      <td
                        colSpan={3}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area1set}
                            ratio={ratio1set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                    </>
                  )}
                  {metadata.kml_ok == 1 && modeset == 3 && (
                    <>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      ></td>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area2set}
                            ratio={ratio2set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード（左側）
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                      <td
                        colSpan={1}
                        className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words"
                      >
                        <>
                          <Csv2kml
                            meta={metadata}
                            area={area1set}
                            ratio={ratio1set}
                            alpha={0.9}
                          >
                            <span className="text-blue-500 underline">
                              KMLダウンロード（右側）
                            </span>
                          </Csv2kml>
                        </>
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>




            <div className="flex justify-center md:my-5 cursor-pointer">
              <div onClick={() => setShow(false)}>閉じる</div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}

// export function Syosai(props) {
//   console.log(props);
//   const metadata = props.metadata;
//   const { area1set, setArea1Set } = useContext(Area1Set);

//   return (

//   );
// }
